<template>
  <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5529 0C13.5514 0 13.548 0 13.5465 0C6.10407 0 0.0528099 6.00524 0 13.4473C0.0452656 20.9112 6.08898 26.9545 13.5537 26.9994C21.0078 26.9994 27.053 20.9542 27.053 13.4997C27.053 6.04522 21.0078 0 13.5529 0Z"
      fill="#FEDB41"
    />
    <path
      d="M13.5522 3.1818C13.536 3.18104 13.5156 3.18104 13.4998 3.18104C7.80196 3.18104 3.18147 7.80153 3.18147 13.4986C3.18147 19.1964 7.80196 23.8169 13.4998 23.8169C19.1972 23.8169 23.8173 19.1964 23.8173 13.4986C23.8173 13.4824 23.8173 13.462 23.8173 13.4458C23.7596 7.80266 19.1957 3.23875 13.5514 3.18066L13.5522 3.1818Z"
      fill="#FEA832"
    />
    <path
      d="M7.39325 13.4768C7.39325 15.3135 8.04559 16.8778 9.35028 18.1699C10.6423 19.4746 12.2066 20.1269 14.0433 20.1269C16.1967 20.1269 17.9384 19.2782 19.2684 17.5809C19.4964 17.2895 19.5914 16.9665 19.5534 16.6118C19.5027 16.2445 19.3317 15.9468 19.0404 15.7188C18.7491 15.4908 18.4261 15.4022 18.0714 15.4528C17.704 15.4908 17.4064 15.6555 17.1784 15.9468C16.3804 16.9602 15.3354 17.4669 14.0433 17.4669C12.9413 17.4669 12.004 17.0742 11.2313 16.2888C10.446 15.5162 10.0533 14.5788 10.0533 13.4768C10.0533 12.3748 10.446 11.4374 11.2313 10.6648C12.004 9.87943 12.9413 9.48676 14.0433 9.48676C15.3354 9.48676 16.3804 9.99343 17.1784 11.0068C17.4064 11.2981 17.704 11.4628 18.0714 11.5008C18.4261 11.5514 18.7491 11.4628 19.0404 11.2348C19.3317 11.0068 19.5027 10.7091 19.5534 10.3418C19.5914 9.98709 19.4964 9.66409 19.2684 9.37275C17.9384 7.6754 16.1967 6.82672 14.0433 6.82672C12.2066 6.82672 10.6423 7.47906 9.35028 8.78375C8.04559 10.0758 7.39325 11.6401 7.39325 13.4768Z"
      fill="#FEDB41"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconBonus',
  }
</script>
